var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdownArrowUp = function SvgDropdownArrowUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.902 14.079l-3.318-4.791a.65.65 0 0 0-.249-.211.76.76 0 0 0-.67 0 .65.65 0 0 0-.249.21L8.098 14.08a.538.538 0 0 0-.01.601.65.65 0 0 0 .25.222.76.76 0 0 0 .344.082h6.636a.76.76 0 0 0 .344-.082.643.643 0 0 0 .25-.222.538.538 0 0 0-.01-.601z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dropdown-arrow-up.74dadcdd02b0f45637292379521fd72b.svg";